// src/pages/AccueilPage.jsx
import React from 'react';
import { Button, Typography, Row, Col, Card, Space } from 'antd';
import { 
  CarOutlined, 
  TeamOutlined, 
  DollarOutlined, 
  SafetyOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined 
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

const AccueilPage = () => {
  const features = [
    {
      icon: <CarOutlined />,
      title: 'Gestion de Flotte',
      description: 'Suivez et gérez votre parc de véhicules',
      color: '#1890ff'
    },
    {
      icon: <TeamOutlined />,
      title: 'Gestion Clients',
      description: 'Centralisez vos relations clients',
      color: '#52c41a'
    },
    {
      icon: <DollarOutlined />,
      title: 'Gestion Financière',
      description: 'Suivez vos revenus et dépenses',
      color: '#faad14'
    },
    {
      icon: <SafetyOutlined />,
      title: 'Sécurité des Données',
      description: 'Vos données sont sécurisées',
      color: '#722ed1'
    }
  ];

  const testimonials = [
    {
      name: 'Amadou Diop',
      role: 'Directeur Transport',
      text: 'Cette application a révolutionné notre gestion logistique.',
      company: 'TransAfrica'
    },
    {
      name: 'Fatou Ndiaye',
      role: 'Responsable Flotte',
      text: 'Interface intuitive et fonctionnalités complètes.',
      company: 'Global Logistics'
    }
  ];

  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <div style={styles.heroContent}>
          <Title style={styles.heroTitle}>
            Latyr Global Business SUARL
          </Title>
          <Text style={styles.heroSubtitle}>
            Optimisez votre gestion logistique avec notre solution complète de gestion de transport.
            Suivi en temps réel, gestion financière intégrée et interface intuitive.
          </Text>
          
          <Space size="large" style={styles.heroButtons}>
            <Link to="/login">
              <Button
                type="primary"
                size="large"
                style={styles.primaryButton}
                icon={<CheckCircleOutlined />}
              >
                Se connecter
              </Button>
            </Link>
            {/*<Link to="/register">
              <Button
                type="default"
                size="large"
                style={styles.secondaryButton}
                icon={<ClockCircleOutlined />}
              >
                S'inscrire
              </Button>
            </Link>*/}
          </Space>
        </div>
      </div>

      {/* Features Section */}
      <div style={styles.section}>
        <Title level={2} style={styles.sectionTitle}>Fonctionnalités Clés</Title>
        <Text style={styles.sectionSubtitle}>
          Tout ce dont vous avez besoin pour gérer efficacement votre activité de transport
        </Text>
        
        <Row gutter={[32, 32]} style={styles.featuresGrid}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <Card 
                hoverable
                style={styles.featureCard}
                bodyStyle={{ textAlign: 'center', padding: '24px' }}
              >
                <div style={{ ...styles.featureIcon, color: feature.color }}>
                  {React.cloneElement(feature.icon, { style: { fontSize: '48px' } })}
                </div>
                <Title level={4} style={{ marginTop: '16px' }}>
                  {feature.title}
                </Title>
                <Text type="secondary">
                  {feature.description}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* Stats Section */}
      <div style={{ ...styles.section, background: '#f0f2f5', padding: '64px 0' }}>
        <Row gutter={[48, 48]} justify="center">
          <Col xs={12} sm={8} lg={4} style={styles.statItem}>
            <Title level={1} style={{ color: '#0a6b5a', margin: 0 }}>500+</Title>
            <Text strong>Clients satisfaits</Text>
          </Col>
          <Col xs={12} sm={8} lg={4} style={styles.statItem}>
            <Title level={1} style={{ color: '#0a6b5a', margin: 0 }}>24/7</Title>
            <Text strong>Support disponible</Text>
          </Col>
          <Col xs={12} sm={8} lg={4} style={styles.statItem}>
            <Title level={1} style={{ color: '#0a6b5a', margin: 0 }}>99.9%</Title>
            <Text strong>Disponibilité</Text>
          </Col>
          <Col xs={12} sm={8} lg={4} style={styles.statItem}>
            <Title level={1} style={{ color: '#0a6b5a', margin: 0 }}>50+</Title>
            <Text strong>Entreprises</Text>
          </Col>
        </Row>
      </div>

      {/* Testimonials */}
      <div style={styles.section}>
        <Title level={2} style={styles.sectionTitle}>Ils nous font confiance</Title>
        
        <Row gutter={[32, 32]} style={{ marginTop: '48px' }}>
          {testimonials.map((testimonial, index) => (
            <Col xs={24} lg={12} key={index}>
              <Card style={styles.testimonialCard}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                  <div style={styles.avatar}>
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <Text strong>{testimonial.name}</Text>
                    <div>
                      <Text type="secondary">{testimonial.role}</Text>
                      <Text type="secondary" style={{ marginLeft: '8px' }}>• {testimonial.company}</Text>
                    </div>
                  </div>
                </div>
                <Text style={{ fontStyle: 'italic' }}>" {testimonial.text} "</Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      {/* CTA Section */}
      <div style={{ ...styles.section, textAlign: 'center', padding: '80px 0' }}>
        <Title level={2}>Prêt à transformer votre gestion de transport ?</Title>
        <Text style={{ fontSize: '18px', color: '#666', marginBottom: '32px', display: 'block' }}>
          Rejoignez des centaines d'entreprises qui nous font déjà confiance
        </Text>
        <Space size="large">
          <Link to="/register">
            <Button type="primary" size="large" style={{ padding: '0 40px', height: '50px' }}>
              Commencer gratuitement
            </Button>
          </Link>
          <Link to="/contact">
            <Button size="large" style={{ padding: '0 40px', height: '50px' }}>
              Contacter un expert
            </Button>
          </Link>
        </Space>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <div style={styles.footerContent}>
          <div>
            <img 
              src="/images/latyr.jpg" 
              alt="Latyr Logo" 
              style={{ height: '50px', borderRadius: '50%', marginBottom: '16px' }}
            />
            <Text strong style={{ color: '#fff', fontSize: '18px' }}>Latyr Global Business</Text>
          </div>
          <div>
            <Text style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              © 2026 DEVTECH Développeur DveOps. Tous droits réservés.
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
  },
  heroSection: {
    position: 'relative',
    height: '100vh',
    backgroundImage: 'url("/images/trans.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(10, 107, 90, 0.9) 0%, rgba(0, 0, 0, 0.7) 100%)',
  },
  heroContent: {
    position: 'relative',
    zIndex: 1,
    textAlign: 'center',
    color: '#fff',
    maxWidth: '800px',
    padding: '40px',
  },
  heroTitle: {
    fontSize: '48px',
    fontWeight: 'bold',
    marginBottom: '24px',
    color: '#fff',
  },
  heroSubtitle: {
    fontSize: '20px',
    marginBottom: '40px',
    color: 'rgba(255, 255, 255, 0.9)',
    lineHeight: '1.6',
  },
  heroButtons: {
    marginTop: '32px',
  },
  primaryButton: {
    padding: '0 40px',
    height: '50px',
    fontSize: '16px',
    borderRadius: '8px',
    background: 'linear-gradient(135deg, #0a6b5a 0%, #0a8c72 100%)',
    border: 'none',
    fontWeight: '500',
  },
  secondaryButton: {
    padding: '0 40px',
    height: '50px',
    fontSize: '16px',
    borderRadius: '8px',
    background: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    color: '#fff',
    fontWeight: '500',
  },
  section: {
    padding: '80px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  sectionTitle: {
    textAlign: 'center',
    marginBottom: '16px',
    color: '#333',
  },
  sectionSubtitle: {
    textAlign: 'center',
    fontSize: '18px',
    color: '#666',
    marginBottom: '48px',
    display: 'block',
  },
  featuresGrid: {
    marginTop: '48px',
  },
  featureCard: {
    borderRadius: '12px',
    border: '1px solid #f0f0f0',
    transition: 'all 0.3s',
    height: '100%',
  },
  featureIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  statItem: {
    textAlign: 'center',
  },
  testimonialCard: {
    borderRadius: '12px',
    background: '#fafafa',
    border: '1px solid #f0f0f0',
    padding: '24px',
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    background: '#0a6b5a',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    marginRight: '16px',
  },
  footer: {
    background: '#1F2937',
    padding: '40px 20px',
    color: '#fff',
  },
  footerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },
};

export default AccueilPage;